import { render, staticRenderFns } from "./MediaPlatform.vue?vue&type=template&id=22c7c683&scoped=true"
import script from "./MediaPlatform.vue?vue&type=script&lang=js"
export * from "./MediaPlatform.vue?vue&type=script&lang=js"
import style0 from "./MediaPlatform.vue?vue&type=style&index=0&id=22c7c683&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7c683",
  null
  
)

export default component.exports